<template>
<level-left class="content-nav">
  <slot></slot>
  <template slot="right">
    <slot name="right"></slot>
  </template>
</level-left>
</template>

<script>
import LevelLeft from '@/components/LevelLeft.vue';

export default {
  name: 'ContentNavBar',
  components: { LevelLeft },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

.content-nav {
    padding: 0 $content-padding;
    margin: 0;
    border-bottom: 1px solid $border-color;
    // background: $sidebar-active;
    min-height: $navbar-height;
    flex: 0;

    .message {
      color: whitesmoke;
      font-size: .9rem;
    }
}

.attention {
  background-color: $attention;
  color: whitesmoke;
}

.warning {
  background-color: $warning;
  color: $main-background;
}

.secondary {
  background-color: $form-subitem;
  color: whitesmoke;
}

</style>
